<template>
  <div class="">
    <div
      id="feature-area"
      class="feature-area pt-100 pb-70 custom-shape-divider"
    >
      <div class="container">
        <div class="section-title faq-title">
          <h2>{{ $t("app.faqs") }}</h2>
        </div>

        <div class="faq-area">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-6 faqs-image">
                <div class="faq-img">
                  <img src="/assets/img/FAQs.svg" />
                </div>
              </div>
              <div class="col-lg-6">
                <div
                  v-if="pgLoading"
                  class="col-12 webkit-animation webkit-none-50 mt-4"
                ></div>
                <div
                  v-if="pgLoading"
                  class="col-12 webkit-animation webkit-none-50 mt-4"
                ></div>
                <div
                  v-if="pgLoading"
                  class="col-12 webkit-animation webkit-none-50 mt-4"
                ></div>
                <div
                  v-if="pgLoading"
                  class="col-12 webkit-animation webkit-none-50 mt-4"
                ></div>

                <ul v-if="!pgLoading" class="accordion">
                  <li
                    v-for="(item, idx) in items"
                    :key="idx"
                    v-on:click="expand($event, idx)"
                  >
                    <a :class="item.active ? 'active' : ''">
                      {{ $i18n.locale == "en" ? item.en.title : item.ar.title }}
                      <i class="icofont-plus"></i>
                      <i class="icofont-minus two"></i>
                    </a>
                    <p
                      :style="item.active ? 'display:block' : ''"
                      v-html="
                        $i18n.locale == 'en'
                          ? item.en.bodyStriped
                          : item.ar.bodyStriped
                      "
                    ></p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQs",
  components: {
    //
  },
  data() {
    return {
      //
      items: [],
      pgLoading: true,
      refs: "faqs",
    };
  },
  mounted() {},
  created() {
    //
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/" + this.refs,
        method: "GET",
        data: {},
        headers: {
          appId: process.env.VUE_APP_APPID,
        },
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.items = res.data.data.rows.map((item, index) => {
            item.active = index === 0;
            return item;
          });
        })
        .catch(() => {
          //
        })
        .finally(() => {
          if (localStorage.getItem("locale") == "ar") {
            document.getElementById("feature-area").classList.add("is-rtl");
          }
        });
    },

    stripHtmlTags(value) {
      if (!value) return "";
      return value.replace(/<[^>]+>/g, "");
    },

    expand(e, i) {
      // reset..
      for (var x = 0; x < this.items.length; x++) {
        this.items[x].active = false;
      }

      this.items[i].active = true;
      // if(this.items[i].active == true) {
      //     this.items[i].active = false;
      // } else {
      //     this.items[i].active = true;
      // }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
